import { useQuery } from 'react-query';

function useRemoteOptions(queryKey: string) {
    return useQuery<{ id: string; name: string }[]>(queryKey, { staleTime: Infinity });
}

export default useRemoteOptions;
